/**
 * Play Button Component
 * Shows on hover on desktop, always visible on mobile
 */

import React from 'react';
import styles from './ButtonPlay.module.css';
import { useTranslator } from '../../../../../../shared/hooks/useTranslations';
import { findTranslationKeyAsGivenJSONTranslationFallback } from '../../../../../../shared/utils/helpers';
import { useIsStartingGame, useIsWaitingForDefenseCode } from '../../../../hooks/useGameStart';

interface ButtonPlayProps {
    onClick: () => void;
    className?: string;
}

const ButtonPlay: React.FC<ButtonPlayProps> = ({ onClick, className = '' }) => {
    const translate = useTranslator();
    const isStartingGame = useIsStartingGame();
    const isWaitingForDefenseCode = useIsWaitingForDefenseCode();

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation(); // Prevent event bubbling to parent card

        // Don't allow clicking if already starting or waiting for defense code
        if (isStartingGame || isWaitingForDefenseCode) {
            return;
        }

        onClick();
    };

    // Show loading state when waiting for defense code or starting
    const isLoading = isStartingGame || isWaitingForDefenseCode;
    const playText = translate('generic_play', findTranslationKeyAsGivenJSONTranslationFallback('generic_play'));

    return (
        <div className={`${styles.playButtonWrapper}`}>
            <div
                className={`${styles.playButton} egt_game_btn_play ${className} ${isLoading ? styles.loading : ''}`}
                onClick={handleClick}
            >
                {isLoading ? (
                    <span className={styles.dots}>
                        <span className={styles.dot}>.</span>
                        <span className={styles.dot}>.</span>
                        <span className={styles.dot}>.</span>
                    </span>
                ) : (
                    playText
                )}
            </div>
        </div>
    );
};

export default ButtonPlay;
